import React, { forwardRef } from 'react';
import MealPlanReportTemplate from '../../../../components/documents-templates/MealPlanReportTemplate';
import { buildReportFileName, generateReportPDF } from '../../../../services/clinicalReportService';
import { findProfessional } from '../../../../components/documents-templates/report/reportCompany';

/**
 * Exportação do plano em PDF para o paciente: o template fica montado fora da
 * tela e `exportMealPlanPdf` o converte com o CreatePDF já usado pelos
 * documentos e pelos relatórios clínicos.
 */
export function exportMealPlanPdf(element, patientName) {
  generateReportPDF(element, buildReportFileName(patientName, 'plano-alimentar'));
}

const MealPlanExport = forwardRef(({ plan, patient, companyConfig, professionalId }, ref) => {
  if (!plan) return null;
  return (
    <div style={{ position: 'absolute', left: '-9999px', top: 0 }} aria-hidden="true">
      <MealPlanReportTemplate
        ref={ref}
        plan={plan}
        patient={patient}
        companyData={companyConfig}
        professional={findProfessional(companyConfig, professionalId)}
      />
    </div>
  );
});

MealPlanExport.displayName = 'MealPlanExport';

export default MealPlanExport;
